import { c as _c } from "react/compiler-runtime";
import { LiraContainerIds } from '@/client/components/Adv/Lira/liraContainerIds';
import { SmartLiraAdvContainer } from '@/client/components/Search/Containers/SmartAdvItem';
import styles from './index.module.scss';
export const AdsBeforeListingBlock = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={styles["adsense-before-listing-container"]}><SmartLiraAdvContainer id={LiraContainerIds.listing.inContentTop} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};